import { useState, useRef, useEffect } from 'react';
import { useWallet } from '../hooks/useWallet';

export function WalletConnect() {
  const { address, isConnected, isConnecting, connect, disconnect } = useWallet();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isDropdownOpen]);

  if (isConnecting) {
    return (
      <button
        disabled
        className="px-3 py-1.5 bg-[#2d3748] text-[#6c7884] rounded-md cursor-not-allowed text-[12px] font-medium"
      >
        Connecting...
      </button>
    );
  }

  if (isConnected && address) {
    return (
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="flex items-center gap-2 px-3 py-1.5 bg-[#0e0f10] border border-[#2d3748] rounded-md hover:border-[#3d444d] transition-colors text-[12px] font-medium"
        >
          <span className="font-mono text-white">
            {`${address.slice(0, 6)}...${address.slice(-4)}`}
          </span>
          <svg
            className={`w-4 h-4 text-[#6c7884] transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {/* Dropdown */}
        {isDropdownOpen && (
          <div className="absolute top-full right-0 mt-2 w-48 bg-[#0e0f10] border border-[#2d3748] rounded-md shadow-lg z-50">
            <div className="p-2">
              <button
                onClick={() => {
                  disconnect();
                  setIsDropdownOpen(false);
                }}
                className="w-full px-3 py-2 text-left text-[12px] font-medium text-[#f6465d] hover:bg-[#1a1d20] rounded-md transition-colors flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Disconnect
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <button
      onClick={() => connect()}
      className="px-3 py-1.5 bg-[#2962ff] hover:bg-[#4176ff] text-white rounded-md transition-colors text-[12px] font-medium"
    >
      Connect Wallet
    </button>
  );
}
